import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const OverdueTasks: React.FC = () => {
  return (
    <HeaderWidget
      title='Overdue Tasks'
      information='This metric measures the number of tasks that have passed their due date without being completed.'
    >
      -
    </HeaderWidget>
  )
}

export default OverdueTasks
